import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useCookieConsent } from './CookieConsent'
import { useUserContext } from './UserProvider'

export const ConsentAwareGTM = () => {
  const router = useRouter()
  const { preferences } = useCookieConsent()
  const ctx = useUserContext()
  const isImpersonated = Boolean(ctx?.user?.impersonator)
  const isDevelopment =
    process.env.NODE_ENV === 'development' || process.env.STAGE === 'dev'

  // Don't load GTM noscript for:
  // - Non-production environments
  // - Login callback routes
  // - Impersonated users
  // - Users who haven't consented to analytics
  const shouldLoadGTM =
    isDevelopment &&
    !router.asPath.startsWith('/login/callback') &&
    !isImpersonated &&
    preferences?.analytics

  // Debug logging for development
  useEffect(() => {
    if (isDevelopment) {
      if (isImpersonated) {
        console.log('🎭 GTM noscript blocked - Impersonator detected')
      } else if (router.asPath.startsWith('/login/callback')) {
        console.log('🔐 GTM noscript blocked - Login callback route')
      } else if (!preferences?.analytics) {
        console.log('🍪 GTM noscript blocked - Analytics consent denied')
      } else if (preferences?.analytics) {
        console.log('📊 GTM noscript allowed - Analytics consent granted')
      }
    }
  }, [preferences?.analytics, isImpersonated, router.asPath])

  if (!shouldLoadGTM) {
    return null
  }

  return (
    <noscript>
      <iframe
        src='https://www.googletagmanager.com/ns.html?id=GTM-5GFXMXL9'
        height='0'
        width='0'
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  )
}
